exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-455ca669] .filters-no-wrap{overflow-x:visible!important;flex-wrap:wrap!important}[data-v-455ca669] .filters-no-wrap>.filter-field{flex-shrink:1!important;min-width:96px!important;flex-basis:96px!important}[data-v-455ca669] .filters-no-wrap>.filter-field-wide{flex-shrink:1!important;min-width:124px!important;flex-basis:124px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-455ca669","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/orderDelivery/orderDeliveries.vue
// module id = 1368
// module chunks = 0